export default function DotIcon ({
    fill = 'black',
    size = 1
}) {
    return (
        <svg width="29px" height={29 * size + "px"} viewBox="0 0 29 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="Final-UI-UX" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Landing-" transform="translate(-1275.000000, -2834.000000)" fill={fill}>
                    <g id="Group-10" transform="translate(-30.000000, 2782.000000)">
                        <rect id="Rectangle-Copy" transform="translate(1319.142136, 66.142136) rotate(45.000000) translate(-1319.142136, -66.142136) " x="1309.14214" y="56.1421356" width="20" height="20"></rect>
                    </g>
                </g>
            </g>
        </svg>
    )
}